import React, { Component } from 'react';
import { SecondsToHHMMSS } from '../../../common/constant';
import { formatTime } from '../../../common/function';

export class ReverseTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: props.initialTimerValue || 0,
    };
    this.timer = null;
  }

  componentDidMount() {
    if (this.props.isTimerRunning) {
      this.startTimer();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isTimerRunning !== this.props.isTimerRunning) {
      if (this.props.isTimerRunning) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer = () => {
    clearInterval(this.timer);
    this.props.onStartTimer && this.props.onStartTimer();
    this.timer = setInterval(this.onHandleTimerChange, 1000);
  };

  stopTimer = () => {
    clearInterval(this.timer);
    this.props.onStopTimer && this.props.onStopTimer();
  };

  onHandleTimerChange = () => {
    const count = this.state.count - 1;
    this.setState({ count });

    this.props.apiCall &&
      this.props.apiCall({
        count,
        timer: count,
      });
  };

  render() {
    const { count } = this.state;
    const { isTimerRunning, disabled } = this.props;
    return (
      <div>
        <div className='timer_outer'>
          <i className='fa fa-clock-o' />

          <span className='timer_box'>{formatTime(count)}</span>
        </div>

        <button
          type='button'
          aria-label={isTimerRunning ? 'Pause timer' : 'Resume timer'}
          className={`pause_btn ${isTimerRunning ? 'icon-control-pause' : 'icon-control-play'}`}
          onClick={this.props.onToggleTimer} // controlled by parent
          disabled={disabled}
        />
      </div>
    );
  }
}

export default ReverseTimer;



// WEBPACK FOOTER //
// ./src/Components-2025/IR/Quiz/ReverseTimer.js